/**
 * Reads the AIChatPracticeSession context. Throws if used outside its provider.
 *
 * Isolated read path for the PracticeSession slice (activity identity + session progress + KCs,
 * plus setters). Each slice context is subscribed to directly — there is no merged value.
 * Scoping the provider to the practice view is deferred to a later ticket.
 */
import { useContext } from 'react';
import { AIChatPracticeSessionContext } from './AIChatPracticeSessionProvider';
import type { AIChatPracticeSessionValue } from './AIChatPracticeSessionProvider';

export function useAIChatPracticeSession(): AIChatPracticeSessionValue {
  const context = useContext(AIChatPracticeSessionContext);
  if (!context) {
    throw new Error('useAIChatPracticeSession must be used within a AIChatPracticeSessionProvider');
  }
  return context;
}
